module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-opening-bbf7e4dd3a8c005ebdfc612d18cbf7cd.svg";